import { render, staticRenderFns } from "./BeOverdue.vue?vue&type=template&id=99d184de&scoped=true&"
import script from "./BeOverdue.vue?vue&type=script&lang=js&"
export * from "./BeOverdue.vue?vue&type=script&lang=js&"
import style0 from "./BeOverdue.vue?vue&type=style&index=0&id=99d184de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d184de",
  null
  
)

export default component.exports